import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "15"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  "fill-rule": "nonzero",
  d: "M5.071 14.426c.448 0 .78-.318.78-.78V5.035L5.766 2.91l1.546 1.705 1.532 1.647c.13.159.332.231.549.231.433 0 .751-.318.751-.737a.74.74 0 0 0-.202-.535L5.72.873a.9.9 0 0 0-.65-.303c-.216 0-.433.087-.635.303L.202 5.223A.74.74 0 0 0 0 5.756c0 .42.318.737.737.737a.72.72 0 0 0 .563-.231l1.546-1.647 1.517-1.69-.072 2.109v8.611c0 .462.318.78.78.78m8.843 0a.87.87 0 0 0 .65-.289l4.22-4.349A.72.72 0 0 0 19 9.254a.737.737 0 0 0-.751-.752.7.7 0 0 0-.55.246l-1.53 1.633-1.547 1.719.072-2.138V1.35c0-.462-.318-.78-.78-.78-.448 0-.78.318-.78.78v8.612l.087 2.11-1.518-1.691-1.56-1.633a.68.68 0 0 0-.55-.246c-.418 0-.736.318-.736.752 0 .216.058.39.202.534l4.234 4.35a.83.83 0 0 0 .621.288"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }